import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { list } from '../static/reading/list';
import { Grid, Header, Statistic } from 'semantic-ui-react';
import {  Link, useParams  } from "react-router-dom";

export default function Reading(props) {
    let text = '';
    
    let id = window.location.pathname.split("/").pop();
    if (isNaN(id)) id = -1;
    else {
        const readmePath = require(`../static/reading/${list[id].filename}.md`);
        fetch(readmePath)
            .then(response => {
            return response.text()
            })
            .then(text => text = text
            )
    }

    return (
        <div id="homepage">
            <Grid>
            <Grid.Column width={6} textAlign='right'>
                <div id="column-left">
                    <Header as='h2'>
                        Statistics
                    </Header>
                    <Statistic>
                        <Statistic.Value>{ list.length }</Statistic.Value>
                        <Statistic.Label>Papers</Statistic.Label>
                    </Statistic>
                </div>
            </Grid.Column>
            <Grid.Column width={10}>
                <div className="sections">
                    { 
                        id == -1 ? 
                            <div>
                                <Header as="h2">
                                    Contents
                                </Header>
                                {
                                    list.map((val, idx) => {
                                        return <div key={ idx }><div onClick={() => window.location.href = `reading/${idx}`}>{`${ val['filename'] }.md (Title: ${ val['title']}) `}</div><div>{ `Date: ${ val['date'] }`}</div></div>
                                    })
                                }
                            </div>
                            :
                            <div>
                                <Header as="h2">
                                    {list[id].title}
                                </Header>
                                <ReactMarkdown
                                    source={text} />
                            </div>
                    }
                </div>
            </Grid.Column>
            </Grid>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Reading.jsx